<template>
    <div>
        <ul class="student">
            <li class="student-li flex-layout"
                v-for="(li,index) in studentList" 
                :key="index"
                @click="$router.push('/news/student/detail/'+ li.id)">
                <img :src="li.image" alt="" :style="imgSize">
                <div class="describe flex-column-between">
                    <h3 class="wes-2">{{li.name}}</h3>
                    <p class="wes-3">{{li.instruction}}</p>
                    <div class="flex-align-between other-info">
                        <span class="time">{{li.createTime}}</span>
                        <span class="eye">{{li.lookNum}}</span>
                    </div>
                </div>
            </li>
        </ul>
        <div class="loading" v-if="showBtn">
            <button class="load-more" @click="getNewsList()" :class="[loadClass?'load-more':'load-more-none']">{{loadText}}</button>                  
        </div>
    </div>
</template>

<script>
export default {
    props: {
        cloumn: {
          type:Number,
        },
        imgWidth:{
            type:Number,

        },
        imgHeight:{
            type:Number,
        },
        pageSize:{
            type:Number
        }
    },
    data() {
        return {
            currentPage:1,
            loadText:'加载更多',
            loadClass:true,
            // pWidth:{
            //     width: this.pWidth ? this.pWidth + 'px' : '277px',
            // },
            imgSize:{
                width: this.imgWidth ? this.imgWidth + 'px' : '253px',
                height: this.imgHeight ? this.imgSize + 'px' : '190px'
            },
            studentList:[],
        }
    },
    computed:{
        calcStyle:function() {
            let lof = 'u-lof'
            this.cloumn ? lof = 'u-lof' + String(this.cloumn) : ''
            return lof;
        },
        showBtn:function(){
            return this.$route.path !== '/news' ? true : false;
        }
    },
    methods:{
        async GetList(){
            let params ={
               isAsc:'desc',
               pageNum:this.currentPage++,
               pageSize:this.pageSize || 6,
               type:2, 
            }
            let resData = await Api.News.getTeaList(params)
            // console.log(resData.rows)

            params.pageNum = this.currentPage;
            let res = await Api.News.getTeaList(params)
            if(res.rows.length < 1) {
                this.loadText = '加载已完成'
                this.loadClass = false;
            }
            
            this.studentList = this.studentList.concat(resData.rows);
      }
    },
    mounted(){
        this.GetList();
    }

}
</script>

<style lang="less" scoped>
    
    .student {
        flex-flow: row wrap;
        align-content: flex-start;

        .u-lof4 {
            flex: 0 0 24%;
        }

        .u-lof3 {
            flex: 0 0 33%;
        }

        .u-lof2 {
            flex: 0 0 49%;
        }

        .student-li {
            margin-bottom: 20px;
            cursor: pointer;

            img {
                display: inline-block;

                background-color: #1c4b90;
            }
            .describe {
                flex: 1;

                padding:20px 4px 10px 19px;;

                &:hover p {
                    color: #1c4b90;
                }
                h3 {
                    // padding: 20px 0 0;

                    font-size: 20px;
                    font-weight: bold;

                    color: #1c4b90;
                }
                // p {
                //     flex-grow: 1;

                //     padding-top: 19px;
                // }
                p, span {
                    
                   font-size: 12px;

                   color: #999;
                }
                
                // .other-info {
                //     padding-bottom: 10px;
                // }

                span::before {
                    content: ' ';
                    display: inline-block;

                    margin-right: 4px;
                    width: 16px;
                    height: 12px;

                    background-repeat: no-repeat;
                }

                span.time::before {
                     background-image: url("../../../../static/news/time@2x.png");
                     background-size: 15px 15px;
                }

                span.eye::before {
                    background-image: url("../../../../static/news/eye@2x.png");
                    background-size: 16px 16px;
                }
            } 
        }
    }

     .loading {
        .load-more {
           margin: 40px auto 88px;
           display: block;
           font-size: 12px;
           color: #333;
           border: 0;
           background: none;
           text-transform: uppercase;
           color: #333;
           font-weight: bold;
           position: relative;
           outline: none;
           padding: 10px 30px;
           box-sizing: border-box;
           cursor: pointer;

          &::before,   &::after {
            box-sizing: inherit;
            position: absolute;
            content: '';
            border: 2px solid transparent;
            width: 0;
            height: 0;
          }
          
          &::after {
            bottom: 0;
            right: 0;
          }
          
          &::before {
            top: 0;
            left: 0;
          }
          &:hover {
             color: #1B4B8F;
          }
 
          &:hover::before,  &:hover::after {
            width: 100%;
            height: 100%;
          }
          
          &:hover::before {
            border-top-color: #1B4B8F;
            border-right-color: #1B4B8F;
            transition: width 0.3s ease-out, height 0.3s ease-out 0.3s;
          }
          
          &:hover::after {
            border-bottom-color: #1B4B8F;
            border-left-color: #1B4B8F;
            transition: border-color 0s ease-out 0.6s, width 0.3s ease-out 0.6s, height 0.3s ease-out 1s;
          }
        }

        .load-more-none {
            color: #999;
            &::before,
            &::after {
                content: none;
            }

            &:hover {
                color: #999;
            }
        }
    }
  
</style>